/*
 * Filmstrip crawl, background pause only.
 *
 * The animation itself is entirely CSS. The one thing CSS cannot express is "stop when nobody is
 * looking", and a 30s infinite transform on a decorative band is exactly the thing that should not
 * keep a compositor thread warm in a background tab. Chrome suspends rendering for hidden tabs,
 * Safari does not always, so this is explicit rather than assumed.
 *
 * The strip is aria-hidden with no focusable children, so there is nothing here to keep in sync
 * beyond one attribute.
 */
const syncCrawl = () => {
  const hidden = document.hidden;
  for (const strip of document.querySelectorAll('.nz-strip')) {
    strip.toggleAttribute('data-nz-strip-hidden', hidden);
  }
};

document.addEventListener('visibilitychange', syncCrawl);
syncCrawl();
